const MESES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
]

const UNIDADES = [
  'cero',
  'uno',
  'dos',
  'tres',
  'cuatro',
  'cinco',
  'seis',
  'siete',
  'ocho',
  'nueve',
]

const ESPECIALES = {
  10: 'diez',
  11: 'once',
  12: 'doce',
  13: 'trece',
  14: 'catorce',
  15: 'quince',
}

const DECENAS = [
  '',
  '',
  'veinte',
  'treinta',
  'cuarenta',
  'cincuenta',
  'sesenta',
  'setenta',
  'ochenta',
  'noventa',
]

const CENTENAS = [
  '',
  'ciento',
  'doscientos',
  'trescientos',
  'cuatrocientos',
  'quinientos',
  'seiscientos',
  'setecientos',
  'ochocientos',
  'novecientos',
]

function normalizarTexto(valor) {
  if (valor == null) return ''
  return String(valor)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

function numeroATexto(valor) {
  const num = Number(valor)
  if (!Number.isFinite(num)) return ''
  const n = Math.trunc(Math.abs(num))
  if (n === 0) return 'cero'
  const base = numeroATextoPositivo(n)
  return num < 0 ? `menos ${base}` : base
}

function numeroATextoPositivo(n) {
  if (n < 10) return UNIDADES[n]
  if (n < 16) return ESPECIALES[n]
  if (n < 20) return `dieci${UNIDADES[n - 10]}`
  if (n === 20) return 'veinte'
  if (n < 30) return `veinti${UNIDADES[n - 20]}`
  if (n < 100) {
    const tens = DECENAS[Math.floor(n / 10)]
    const unit = n % 10
    return unit ? `${tens} y ${UNIDADES[unit]}` : tens
  }
  if (n === 100) return 'cien'
  if (n < 200) return `ciento ${numeroATextoPositivo(n - 100)}`
  if (n < 1000) {
    const hundreds = CENTENAS[Math.floor(n / 100)]
    const rest = n % 100
    return rest ? `${hundreds} ${numeroATextoPositivo(rest)}` : hundreds
  }
  if (n === 1000) return 'mil'
  if (n < 2000) {
    const rest = n - 1000
    return rest ? `mil ${numeroATextoPositivo(rest)}` : 'mil'
  }
  if (n < 1000000) {
    const thousands = Math.floor(n / 1000)
    const rest = n % 1000
    const prefix = `${numeroATextoPositivo(thousands)} mil`
    return rest ? `${prefix} ${numeroATextoPositivo(rest)}` : prefix
  }
  if (n < 2000000) {
    const rest = n - 1000000
    return rest ? `un millon ${numeroATextoPositivo(rest)}` : 'un millon'
  }
  const millions = Math.floor(n / 1000000)
  const rest = n % 1000000
  const prefix = `${numeroATextoPositivo(millions)} millones`
  return rest ? `${prefix} ${numeroATextoPositivo(rest)}` : prefix
}

function pad2(valor) {
  return String(valor).padStart(2, '0')
}

function construirFecha(year, month, day, hour = 0, minute = 0, second = 0) {
  const y = Number(year)
  const m = Number(month)
  const d = Number(day)
  const h = Number(hour)
  const min = Number(minute)
  const s = Number(second)

  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null

  const date = new Date(y, m - 1, d, h, min, s)
  if (
    date.getFullYear() !== y ||
    date.getMonth() !== m - 1 ||
    date.getDate() !== d
  ) {
    return null
  }
  return date
}

function parseFechaInput(valor) {
  if (valor == null) return null

  if (valor instanceof Date) {
    return Number.isNaN(valor.getTime()) ? null : valor
  }

  const raw = String(valor).trim()
  if (!raw) return null

  const rawLower = raw.toLowerCase()
  if (rawLower === 'hoy') return new Date()

  if (/^\d+$/.test(raw)) {
    const ms = Number(raw)
    if (Number.isFinite(ms)) {
      const d = new Date(ms)
      return Number.isNaN(d.getTime()) ? null : d
    }
  }

  let match = raw.match(
    /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ t](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/i
  )
  if (match) {
    return construirFecha(match[1], match[2], match[3], match[4], match[5], match[6])
  }

  match = raw.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
  )
  if (match) {
    return construirFecha(match[3], match[2], match[1], match[4], match[5], match[6])
  }

  match = raw.match(
    /^(\d{1,2})-(\d{1,2})-(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
  )
  if (match) {
    return construirFecha(match[3], match[2], match[1], match[4], match[5], match[6])
  }

  match = raw.match(
    /^(\d{4})\/(\d{1,2})\/(\d{1,2})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
  )
  if (match) {
    return construirFecha(match[1], match[2], match[3], match[4], match[5], match[6])
  }

  const fallback = new Date(raw)
  return Number.isNaN(fallback.getTime()) ? null : fallback
}

function obtenerValorEntrada(valor) {
  if (Array.isArray(valor)) {
    const found = valor.find((v) => v != null && v !== '')
    return found == null ? '' : found
  }
  return valor
}

export function fechaMostrar(fechaUhoy, formato) {
  const rawFecha = obtenerValorEntrada(fechaUhoy)
  const fecha = parseFechaInput(rawFecha)
  if (!fecha) return ''

  const formatoNormalizado = normalizarTexto(formato)
  const format = formatoNormalizado || 'dd/mm/yyyy'

  const day = fecha.getDate()
  const month = fecha.getMonth() + 1
  const year = fecha.getFullYear()

  switch (format) {
    case 'dd/mm/yy':
      return `${pad2(day)}/${pad2(month)}/${String(year).slice(-2)}`
    case 'dd/mm/yyyy':
      return `${pad2(day)}/${pad2(month)}/${year}`
    case 'dianum':
      return String(day)
    case 'mesnum':
      return String(month)
    case 'anionum':
      return String(year)
    case 'dialetra':
      return numeroATexto(day)
    case 'mesletra':
      return MESES[month - 1] || ''
    case 'anioletra':
      return numeroATexto(year)
    default:
      return ''
  }
}
